@use "../../styles/variables" as vars;

.overlay {
  position: fixed;
  z-index: 1100;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgb(0 0 0 / 58%);
}

.modal {
  width: min(100%, 680px);
  max-height: min(86vh, 760px);
  overflow: hidden;
  border-radius: vars.$radius-md;
  background: vars.$color-surface;
  box-shadow: 0 18px 60px rgb(0 0 0 / 28%);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  background: vars.$color-primary;
  color: #fff;

  h2 {
    margin: 0;
    font-family: vars.$font-heavy;
    font-size: 22px;
  }

  button {
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 27px;
    line-height: 1;
  }
}

.content {
  max-height: calc(min(86vh, 760px) - 60px);
  overflow-y: auto;
  padding: 18px;
  overscroll-behavior: contain;
}

.intro {
  margin: 0 0 14px;
  color: vars.$color-muted;
  font-size: 15px;
  line-height: 1.45;
}

.list {
  border-top: 1px solid vars.$color-border;
}

.item {
  border-bottom: 1px solid vars.$color-border;

  summary {
    padding: 13px 2px;
    color: vars.$color-text;
    cursor: pointer;
    font-family: vars.$font-heavy;
    font-size: 16px;
    line-height: 1.3;
  }

  &[open] summary {
    color: vars.$color-primary;
  }
}

.answer {
  padding: 0 2px 14px 18px;
  color: vars.$color-muted;
  font-size: 15px;
  line-height: 1.5;

  p {
    margin: 0 0 9px;
  }

  p:last-child,
  ul:last-child,
  section:last-child ul {
    margin-bottom: 0;
  }

  ul {
    margin: 0 0 10px;
    padding-left: 18px;
  }

  li + li,
  section + section {
    margin-top: 5px;
  }

  strong {
    display: block;
    margin-bottom: 4px;
    color: vars.$color-text;
    font-family: vars.$font-heavy;
  }
}

@media (max-width: 600px) {
  .overlay {
    padding: 10px;
  }

  .modal {
    max-height: 90vh;
  }

  .header {
    padding: 12px 14px;

    h2 {
      font-size: 20px;
    }
  }

  .content {
    max-height: calc(90vh - 56px);
    padding: 14px;
  }

  .intro,
  .answer {
    font-size: 14px;
  }

  .item summary {
    font-size: 15px;
  }
}
